module.exports = __webpack_public_path__ + "img/10.7080a8a9.jpg";